import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { toggleHelp } from '../../../+state/app.actions';
import { GopherBuddyAppState } from '../../../+state/app.state';
import { GBMessages } from '../../../../background-service-worker/services/message-handler/message-handler.interfaces';
import { MaterialModule } from '../../material/material.module.ts/material/material.module';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-gb-footer',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './gb-footer.component.html',
  styleUrls: ['./gb-footer.component.scss'],
})
export class GbFooterComponent {
  public appState: Observable<GopherBuddyAppState> = this.appStore;

  constructor(private uiService: UiService, private appStore: Store<GopherBuddyAppState>) {}

  public appSyncing = false;

  public checkVersionEnabled = (appState: GopherBuddyAppState): boolean =>
    appState.app.settings?.customerState.customerSettings?.settings.allowChromeOsUpdateReminders ?? false;

  public recheckBrowserVersion = (): void => {
    this.appSyncing = true;
    chrome.runtime.sendMessage(GBMessages.CHECK_VERSION, (response: { success: boolean }) => {
      this.appSyncing = false;
      const message = response.success ? 'Version check successful' : 'Version check failed';
      this.uiService.showNotification('version_check', message);
    });
  };

  public resyncExtension = (): void => {
    this.appSyncing = true;
    chrome.runtime.sendMessage(GBMessages.RESYNC_EXTENSION, (response: { success: boolean }) => {
      this.appSyncing = false;
      const message = response.success ? 'Resync successful' : 'Resync failed';
      this.uiService.showNotification('resync', message);
    });
  };

  public reloadExtension = (): void => {
    chrome.runtime.sendMessage(GBMessages.RELOAD_EXTENSION, () => {});
  };

  public showHelp = (appState: GopherBuddyAppState) => {
    this.appStore.dispatch(toggleHelp({ open: !appState.app.helpOpen }));
  };

  public openFAQ = () => {
    chrome.runtime.sendMessage(GBMessages.OPEN_FAQ, () => {});
  };
}
